import { InfoCircleTwoTone } from '@ant-design/icons';
import { Button, Descriptions, type DescriptionsProps } from 'antd';
import React from 'react';

import { QuestionTooltip } from '@client/components/QuestionTooltip';
import { getTranslatedMessage } from '@client/utils/i18n.util';
import { tsToLocaleDateTime } from '@common/utils';

import styles from './components.module.less';

import type { IMetadata } from '@common/types';
import type { CollapsibleType } from 'antd/es/collapse/CollapsePanel';
import type { NavigateFunction } from 'react-router';

type TProps = {
  navigate: NavigateFunction;
  disabled?: boolean;
  metadata: IMetadata;
};

export const formMainInfo = (props: TProps) => {
  const { disabled, metadata, navigate } = props;

  const { createdBy, updatedBy, updatedAt, createdAt } = metadata || {};

  const t = getTranslatedMessage;

  const detailsEntity = t('form.metadata');

  const items: DescriptionsProps['items'] = [
    {
      label: t('form.createdBy'),
      children: createdBy ? (
        <Button
          variant="filled"
          color="primary"
          type="link"
          onClick={() => navigate(`/users/${createdBy.uid}`)}
          disabled={disabled}
        >
          {createdBy.name}
        </Button>
      ) : (
        t('error.na')
      ),
    },
    {
      label: t('form.updatedBy'),
      span: 'filled',
      children: updatedBy ? (
        <Button
          variant="filled"
          type="link"
          color="primary"
          onClick={() => navigate(`/users/${updatedBy.uid}`)}
          disabled={disabled}
        >
          {updatedBy.name}
        </Button>
      ) : (
        t('error.na')
      ),
    },
    {
      label: t('form.createdAt'),
      children: tsToLocaleDateTime(createdAt),
    },
    {
      label: t('form.updatedAt'),
      span: 'filled',
      children: tsToLocaleDateTime(updatedAt),
    },
  ];

  return {
    key: 'entityInfo',
    collapsible: (disabled ? 'disabled' : 'header') as CollapsibleType,
    label: (
      <div className={styles.chipLabel}>
        <InfoCircleTwoTone />
        {t('form.entityInfo', detailsEntity)}
      </div>
    ) as React.JSX.Element,
    children: (
      <Descriptions
        bordered
        layout="vertical"
        column={{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }}
        items={items}
      />
    ),
    extra: <QuestionTooltip title={t('form.metadata.helper')} />,
  };
};
